export default {"src":"/_next/static/media/neutral-profile.9099445d.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};